import { reactive } from "vue";

const theme = reactive({
  agentLogo: "",
  devLogo: "logo.png",
  apiUrl: "https://api.metaluxe.com.au/",
  bunnyApiUrl: "https://api.bunny.net/",

  videoLibraryId: "342077",
  streamCdnUrl: "https://vz-0b99d016-a14.b-cdn.net",
  streamApiKey: "5379354d-9733-4112-b5ab7652e8e1-b94a-4ee0",

  storageApiPassword: "862daa3c-5c69-46db-835d9051fa5b-5f22-4d27",
  cdnUrl: "https://plusstudio.b-cdn.net",
  devFolder: "/plusstudio",

  videosIcon: "/img/ui-theme/videos-icon.svg",
  rendersIcon: "/img/ui-theme/renders-icon.svg",
  rangeIcon: "/img/ui-theme/range-icon.svg",
  panoramasIcon: "/img/ui-theme/panoramas-icon.svg",
  floorplansIcon: "/img/ui-theme/floorplans-icon.svg",
  dashboardMp4: "theme/dashboard/4K_dashboard.mp4",
  bgImage: "theme/dashboard/bgImage.jpg",
  // top level menu
  assetsMenuOrder: ["presents", "renders", "cinematics", "360-tour"],

  tourMenuOrder: ["retreat", "nera", "panorama"],
  amenityMenuOrder: [
    "infinity-terrace-flythrough",
    "infinity-terrace-360-tour",
    "infinity-terrace-renders",
  ],

  skylineMenuOrder: [
    "skyline-walkthrough",
    "skyline-360-tour",
    "skyline-renders",
  ],

  canopyMenuOrder: ["canopy-walkthrough", "canopy-360-tour", "canopy-renders"],

  savannaMenuOrder: [
    "savanna-walkthrough",
    "savanna-360-tour",
    "savanna-renders",
  ],

  broadviewMenuOrder: [
    "broadview-walkthrough",
    "broadview-360-tour",
    "broadview-renders",
  ],
  hinterlandMenuOrder: [
    "hinterland-walkthrough",
    "hinterland-360-tour",
    "hinterland-renders",
  ],
  balconyMenuOrder: [
    "skyline-villa-1",
    "canopy-villa-10",
    "savanna-villa-20",
    "broadview-villa-24",
    "broadview-villa-36",
    "hinterland-villa-44",
  ],

  neraAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: ["Nera"],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/23/"],
    renders: [],
  },

  retreatAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: ["Retreat"],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/51/"],
    renders: [],
  },

  panoramaAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: ["Panorama"],
    panoramasUrl: ["https://storage.net-fs.com/hosting/7566552/108/"],
    renders: [],
  },
});

export default { theme };
